import { render } from "./Home3.vue?vue&type=template&id=385eaf64"
import script from "./Home3.vue?vue&type=script&lang=js"
export * from "./Home3.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__